/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/en-us'

import iconSet from 'quasar/icon-set/material-icons'


import Vue from 'vue'

import {Quasar,LocalStorage,SessionStorage,Cookies,Notify,Dialog,LoadingBar,Dark,Loading,AppFullscreen} from 'quasar'


Vue.use(Quasar, { config: {"loading":{"spinnerSize":"4rem","spinnerColor":"primary","message":"Processing request, please wait"},"notify":{"timeout":3000,"position":"bottom","actions":[{"icon":"close","color":"white"}]},"loadingBar":{"color":"primary","size":"3px"}},lang: lang,iconSet: iconSet,plugins: {LocalStorage,SessionStorage,Cookies,Notify,Dialog,LoadingBar,Dark,Loading,AppFullscreen} })
